import debounce from 'lodash/debounce';

/**
 * Debounce decorator for functions inside a vue component.
 *
 * @param {number} delay - delay in milliseconds to wait
 */
export function Debounce(delay: number) {
	return (target: any, prop: string) => {
		return {
			configurable: true,
			enumerable: false,
			value: debounce(target[prop], delay)
		};
	};
}

/**
 * Drop a @Debounce-decorated method's pending call. Call from beforeDestroy so a trailing
 * invocation can't fire against a component that is already gone. Typed loosely because the
 * decorator can't widen the method's declared type to lodash's debounced shape.
 *
 * @param {unknown} method - the decorated method itself, e.g. `this.debouncedSearch`
 * @return {void}
 */
export function cancelDebounce(method: unknown): void {
	(method as { cancel?: () => void })?.cancel?.();
}